<template>
    <div class="form-type-2">
        <OptionsText :defaultToggle="true" v-model="options.text" :defaultVal="defaultOptions.text" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" :narrow="true" />
        <OptionsSbi v-model="options.sbi" :defaultVal="defaultOptions.sbi" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsCompanySize v-model="options.company_size" :defaultVal="defaultOptions.company_size" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsLocation v-model="options.location" :defaultVal="defaultOptions.location" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsFounded v-model="options.founded" :defaultVal="defaultOptions.founded" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsOrgType v-model="options.orgtype" :defaultVal="defaultOptions.orgtype" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsSocials v-model="options.socials" :defaultVal="defaultOptions.socials" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
        <OptionsApps v-model="options.apps" :defaultVal="defaultOptions.apps" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" :narrow="true" />
        <OptionsRelations v-model="options.relations" :defaultVal="defaultOptions.relations" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" :narrow="true" />
        <OptionsBag v-model="options.bag" :defaultVal="defaultOptions.bag" @update:modelValue="onChanged" cssClass="toggle-type-3" cssClassOptions="options-type-5" :showDescriptions="false" />
    </div>
</template>

<script>
    import { mapState, mapActions } from 'pinia';
    import { useCompaniesStore } from '@/stores/companies';
    import OptionsFounded from '@/components/companies/filters/OptionsFounded';
    import OptionsLocation from '@/components/companies/filters/OptionsLocation';
    import OptionsApps from '@/components/companies/filters/OptionsApps';
    import OptionsOrgType from '@/components/companies/filters/OptionsOrgType';
    import OptionsSocials from '@/components/companies/filters/OptionsSocials';
    import OptionsRelations from '@/components/companies/filters/OptionsRelations';
    import OptionsText from '@/components/companies/filters/OptionsText';
    import OptionsSbi from '@/components/companies/filters/OptionsSbi';
    import OptionsBag from '@/components/companies/filters/OptionsBag';
    import OptionsCompanySize from '@/components/companies/filters/OptionsCompanySize';

    export default {
        name: 'CompaniesOptions',
        components: {
            OptionsLocation,
            OptionsApps,
            OptionsFounded,
            OptionsOrgType,
            OptionsSocials,
            OptionsRelations,
            OptionsText,
            OptionsSbi,
            OptionsBag,
            OptionsCompanySize
        },
        computed: {
            ...mapState(useCompaniesStore, ['options', 'defaultOptions', 'hasDefaultOptions', 'audienceId']),
        },
        methods: {
            ...mapActions(useCompaniesStore, ['updateOptions']),
            onChanged() {
                this.updateOptions(this.options);
            }
        }
    }
</script>